<template>
    <div>
          <el-dialog
            title="导入领券会员"
            :visible.sync="showDialog"
            width="550px"
            :close-on-click-modal="false"
            :before-close="handleClose"
            >
            <div class="titel">
                <span>第一步：请选择相应模板，根据模板填入数据</span><a href="https://s3plus.meituan.net/v1/mss_61ac5135885c44e59bbaa7e9b2f3282e/rms-marketing/activity/%E9%A2%86%E5%88%B8%E4%BC%9A%E5%91%98%E5%AF%BC%E5%85%A5.xls" target="_blank" class="activeText">点击下载</a>
            </div>
            <div class="titel mt10" >
                <span>第二步：导入上传数据</span>
            </div>
            <el-upload
                class="upload-demo"
                drag
                :action="$uploadURL"
                 :file-list="fileList"
                 accept=".xls,.xlsx"
                 :on-success="handleSuccess"
                multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                    <div><em><i>点击上传</i></em>或将文件拖到此区域</div>
                    <div class="uploadTips">每次导入限制数量应小于50万条，文件小于20M</div>
                    <div class="uploadTips">只能上传 xls | xlsx 格式的文件</div>
                    <div class="uploadTips">如果在导入过程中修改优惠券模板，修改提交后的数据将按照新模板发券</div>
                </div>
             </el-upload>
             <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="confirm" :disabled="fileList.length == 0 ? true:false">开始导入</el-button>
            </span>
          </el-dialog>
    </div>
</template>

<script>
export default {
    data(){
        return {
            fileList:[],
            total:0,
           showDialog:false,
        }
    },
     props:{
        dialogImportVisible:{
            type: Boolean,
            default:false,
        }
     },
     watch:{
        dialogImportVisible:{
            handler(newVal,oldVal){
                this.showDialog = newVal
            },
            deep:true,
            immediate:true,
        }
     },
      methods:{
        cancel(){

        },
        confirm(){
           this.$emit('handleImportClose',false)
           this.showDialog = false
        },
        //下载文件
        downLoadFile(row){
        //window.open(downloadPath)
        },
        handleClose(){
             this.$emit('handleImportClose',false)
             this.showDialog = false
        },
        //文件上传成功
        handleSuccess(res, file, fileList){
           console.log('上传',res,file);
        },
     }
}
</script>

<style lang="less" scoped>
 /deep/ .el-table th>.cell{
    font-size: 15px;
    color: #222;
    font-weight: 500;
 }
 /deep/ .el-dialog__header{
    border-bottom: 1px solid #e5e5e5;
 }
 /deep/ .el-dialog__footer{
    border-top: 1px solid #e5e5e5;
 }
 /deep/ .el-dialog__body{
   padding: 24px;
 }
 .titel{
    font-size: 17px;
    color: #333;
    line-height: 24px;
    margin-bottom: 8px;
 }
 .activeText{
    color: #fe8c00;
    cursor: pointer;
 }
 /deep/ .el-upload-dragger .el-upload__text{
    font-size: 15px;
 }
 /deep/ .el-upload-dragger .el-upload__text em{
     color: #fe8c00;
 }
 .uploadTips{
    color: rgba(0,0,0,.43);
    line-height: 25px;
    font-size: 15px;
 }
 /deep/ .el-upload-dragger{
    border: none;
    background: rgba(0,0,0,0.04);
    border-color: rgba(0,0,0,.15);
    width: 502px !important;
    height: 220px;
 }
  /deep/ .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
    color: #999;
    background: #eee;
    border-color: #d9d9d9;
}
</style>